/**
 * Screen G — claim (§4.2 G, §11.1): `/claim/:token` exchanges the one-time token for the HttpOnly claim session
 * (token never kept in the URL), `/claim` runs Choose → Verify → Review & submit, `/claim/status` shows the win ID,
 * the status timeline and the "Message us on [platform]" hand-off (`/go/:winId/:platform`, winners module).
 */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const ClaimLinkPage = lazyRoute(() => import('./ClaimLinkPage'));
const ClaimPage = lazyRoute(() => import('./ClaimPage'));
const ClaimStatusPage = lazyRoute(() => import('./ClaimStatusPage'));

export const claimRoutes: RouteObject[] = [
  { path: '/claim/:token', element: <ClaimLinkPage /> },
  { path: '/claim', element: <ClaimPage /> },
  { path: '/claim/status', element: <ClaimStatusPage /> },
];
